import { Button, Modal } from '@/components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AssociateAutomationInfrastructureCostForm } from './AssociateAutomationInfrastructureCostForm';

type AssociateInfrastructureCostModalButtonProps = {
  automationId: number;
};

export const AssociateInfrastructureCostModalButton = ({
  automationId,
}: AssociateInfrastructureCostModalButtonProps) => {
  const { t } = useTranslation();
  const [isModalOpen, setModalOpen] = useState(false);

  const handleClose = () => setModalOpen(false);

  return (
    <>
      <Button onClick={() => setModalOpen(true)}>{t('associate_cost')}</Button>
      <Modal
        isOpen={isModalOpen}
        title={t('associate_infrastructure_cost')}
        className="h-fit w-128"
        handleClose={handleClose}
      >
        <AssociateAutomationInfrastructureCostForm
          automationId={automationId}
          onCancel={handleClose}
          onSubmit={handleClose}
        />
      </Modal>
    </>
  );
};
